import { toast } from '@/components/toast';
import { logger } from '@/services/logger';
import { useMutation, useQuery } from 'react-query';
import { CreateCampaignSessionPayload, UpdateCampaignSessionPayload } from '../types';
import { createSession, getCampaign, sendAnalytic } from './api';

const GET_CAMPAIGN_KEY = 'GET_CAMPAIGN_KEY';

export const useGetCampaign = ({
    campaignId,
    clientKey,
    onError: handleError,
}: {
    campaignId: string;
    clientKey: string;
    onError: () => void;
}) => {
    return useQuery(GET_CAMPAIGN_KEY, () => getCampaign({ campaignId, clientKey }), {
        refetchOnWindowFocus: false,
        onError: error => {
            handleError();
            logger.error(`Failed to fetch campaign: ${campaignId}`, error);
            toast.error({
                title: 'Failed to fetch campaign',
                toastId: 'fetch-campaign-error',
            });
        },
    });
};

export const useCreateSession = ({
    campaignId,
    clientKey,
    onSettled: handleSettled,
}: {
    campaignId: string;
    clientKey: string;
    onSettled: () => void;
}) => {
    return useMutation((data: CreateCampaignSessionPayload) => createSession({ campaignId, clientKey, data }), {
        onError: error => {
            logger.error(`Failed to create session for campaign: ${campaignId}`, error);
            toast.error({
                title: 'Failed to create session',
                toastId: 'create-session-error',
            });
        },

        onSettled: handleSettled,
    });
};

export const useSendAnalytic = ({ campaignId, clientKey, sessionId }: { campaignId: string; clientKey: string; sessionId: string }) => {
    return useMutation((data: UpdateCampaignSessionPayload) => sendAnalytic({ campaignId, clientKey, sessionId, data }), {
        onError: error => {
            logger.error(`Failed to send analytics for campaign: ${campaignId}`, error);
        },
    });
};
